module.exports = __webpack_public_path__ + "img/kep12.b257dd25.jpg";